const eventArtwork = {
  contact: {
    src: "/static/assets/events/horde-contact-v1.webp",
    alt: "Illustration of bunker defenders holding a rain-soaked entrance against an approaching horde.",
  },
  breach: {
    src: "/static/assets/events/horde-breach-v1.webp",
    alt: "Illustration of survivors falling back through a damaged bunker corridor as the horde breaches the outer rooms.",
  },
  overrun: {
    src: "/static/assets/events/horde-overrun-v1.webp",
    alt: "Illustration of survivors evacuating through rain while their overrun bunker burns behind them.",
  },
  expedition_return: {
    src: "/static/assets/events/expedition-return-v1.webp",
    alt: "Illustration of an exhausted scavenging team returning through rain with salvaged supplies.",
  },
  research_breakthrough: {
    src: "/static/assets/events/research-breakthrough-v1.webp",
    alt: "Illustration of survivors testing a rebuilt filtration prototype in a bunker workshop.",
  },
  bunker_rebuild: {
    src: "/static/assets/events/bunker-rebuild-v1.webp",
    alt: "Illustration of survivors reinforcing and lighting a newly excavated bunker chamber.",
  },
  memorial: {
    src: "/static/assets/events/memorial-v1.webp",
    alt: "Illustration of survivors keeping a quiet memorial beside an empty bunker bed.",
  },
} as const;

export type EventArtworkVariant = keyof typeof eventArtwork;

export function EventArtwork({
  variant,
  caption,
  compact = false,
}: {
  variant: EventArtworkVariant;
  caption: string;
  compact?: boolean;
}) {
  const artwork = eventArtwork[variant];

  return (
    <figure className={`event-artwork event-artwork-${variant} ${compact ? "event-artwork-compact" : ""}`}>
      <img
        src={artwork.src}
        alt={artwork.alt}
        width={1280}
        height={720}
        decoding="async"
        loading={compact ? "lazy" : "eager"}
      />
      <figcaption>{caption}</figcaption>
    </figure>
  );
}
